angular.module('impactx.dashboard').controller('DashboardBasketCtrl', ['$scope', 'dataGen', DashboardBasketCtrl]);

function DashboardBasketCtrl($scope, dataGen) {
    dataGen.getData($scope, {}, "/dashboard/basket");
}